import { SVGAttributes } from 'react';

interface CustomSVGProps extends SVGAttributes<SVGElement> {
  className?: string;
  fill?: string;
}

const CheckIcon = ({ className, fill = `hiete` }: CustomSVGProps) => {
  return (
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill={fill}
      color={fill}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3659 0.234229C11.5159 0.384251 11.6002 0.587698 11.6002 0.799829C11.6002 1.01196 11.5159 1.21541 11.3659 1.36543L4.96593 7.76543C4.8159 7.91541 4.61246 7.99966 4.40033 7.99966C4.18819 7.99966 3.98475 7.91541 3.83473 7.76543L0.634726 4.56543C0.488999 4.41455 0.408364 4.21247 0.410186 4.00271C0.412009 3.79295 0.496144 3.5923 0.644471 3.44397C0.792797 3.29565 0.993447 3.21151 1.2032 3.20969C1.41296 3.20787 1.61504 3.2885 1.76593 3.43423L4.40033 6.06863L10.2347 0.234229C10.3847 0.0842524 10.5882 0 10.8003 0C11.0125 0 11.2159 0.0842524 11.3659 0.234229Z"
        fill={fill}
        color={fill}
      />
    </svg>
  );
};

export default CheckIcon;
